module.exports = __webpack_public_path__ + "img/confirm-validation.4bbe98e3.svg";